import { useState, useEffect, useContext } from "react";
import { ClientContext } from "../../../contexts/clientProvider";
import { EquipamentosContext } from "../../../contexts/equipamentosProvider";
import ProgressCards from "./progressCard";
import EquipamentoTable from "./equipamentosTable";
import LoadingSpinner from "../../Loader/load";
import BaseButton from "../../General/FormsComp/Button/BaseButton";

const Equipamentos = ({ cliente, closeModal }) => {
  const { clientes } = useContext(ClientContext);
  const { getEquipamentosByClient, equipamentos, loading, setEquipamentos } = useContext(EquipamentosContext);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);


  useEffect(() => {
    let client = clientes.find((client) => client.id === cliente);
    setClienteSelecionado(client);
    setEquipamentos(null);
    getEquipamentosByClient(client.id);
  }, [cliente]);

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4' onClick={closeModal}>
      <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col' onClick={(e) => e.stopPropagation()}>
        <div className='bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6'>
          <h1 className='text-2xl font-bold text-white mb-4'>
            Equipamentos - {clienteSelecionado && clienteSelecionado.nome}
          </h1>
        </div>
        <div className='flex-1 overflow-y-auto p-6'>
          <ProgressCards />
          {!equipamentos && loading ? (<LoadingSpinner />) : <EquipamentoTable dados={equipamentos} cliente={clienteSelecionado} />}
        </div>
        
        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end">
          <BaseButton onClick={closeModal} variant="ghost" size="md">
            Fechar
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default Equipamentos;
